import connector, { Connector } from 'Utils/connector';
import SignupForm from 'Webapp/shared/app/components/auth/signup-form';
import {
  authFormUpdate,
  userSignup,
  connectWithSSO,
  setSSOError,
  getPasswordStrength,
  populateAuthentication,
  setSignupCompleted,
} from 'Webapp/shared/app/redux/actions/auth-actions';
import {
  usageTrackSignupEnter,
  usageTrackSignupExit,
} from 'Webapp/shared/app/redux/actions/usage-actions';
import { getInviteSection } from 'Webapp/shared/app/redux/selectors/section';
import { isPhone } from 'Webapp/shared/app/redux/selectors/viewport';
import { authForm } from 'Webapp/shared/app/redux/selectors/auth';

const selectors = {
  authForm,
  logoSize: (state: Flipboard.State) => (isPhone(state) ? 40 : 80),
  sectionInvite: (state: Flipboard.State) => getInviteSection(state),
};

const actions = {
  authFormUpdate,
  userSignup,
  connectWithSSO,
  setSSOError,
  getPasswordStrength,
  populateAuthentication,
  usageTrackSignupEnter,
  usageTrackSignupExit,
  setSignupCompleted,
};

export type SignupFormContainerProps = Flipboard.ConnectorProps<
  typeof selectors,
  typeof actions
>;

const signupConnector: Connector = {
  selectors,
  actions,
};

const SignupContainer = connector(signupConnector)(SignupForm);

export default SignupContainer;
